"use strict";

/*
 * Cookie names shared across the frontend. Keep the literal here so a rename happens once and
 * no module repeats the string.
 */
export const COOKIE_NAMES = {
    // Per-visitor analytics id. A GUID set for every visitor, signed in or not.
    VISITOR_ID: "VisitorId"
};
